module.exports = __webpack_public_path__ + "img/where-to-buy-md.62d04fe5.jpg";